import { ColumnsContext } from 'components/Table/contexts';
import { ColumnConfig, UpdateConfig } from 'components/Table/contexts/ColumnsContext/types';
import { BaseRow } from 'components/Table/types';
import { MutableRefObject, useContext, useEffect } from 'react';

/** grabs all safe column attributes for saving */
const columnToJson = ({ name, visible, order }: ColumnConfig<BaseRow>): UpdateConfig => {
  return {
    name,
    visible,
    order,
  };
};

export const useColumnsRef = ({
  columnsRef,
  skip = false,
}: {
  skip?: boolean;
  columnsRef?: MutableRefObject<UpdateConfig[]>;
}) => {
  const { columns } = useContext(ColumnsContext);

  useEffect(() => {
    if (skip || !columnsRef) {
      return;
    }
    const nextColumnsJson = columns.map(columnToJson);
    columnsRef.current = nextColumnsJson;
  }, [columns, columnsRef, skip]);
};
